export default (elementTypePredicateFn) =>
    ({ monitor }) => {
        const item = monitor.getItem();
        return !item.element || !item.draggedElements.every(elementTypePredicateFn);
    };
